import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      className={cn(
        "nb-input shadow-sm transition-colors",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
